import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=4d439ae1&"
import script from "./departments.vue?vue&type=script&lang=js&"
export * from "./departments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d439ae1')) {
      api.createRecord('4d439ae1', component.options)
    } else {
      api.reload('4d439ae1', component.options)
    }
    module.hot.accept("./departments.vue?vue&type=template&id=4d439ae1&", function () {
      api.rerender('4d439ae1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/departments.vue"
export default component.exports